import { sessionFromTokens } from '@jq4race/api-client';

import type { SessionFactory } from '../../application/ports/session-factory';

export const createApiClientSession: SessionFactory = (input) => sessionFromTokens(input);
